<template>
  <div>
    <player-derbies-table
      v-if="isDerbiesTableVisible"
      :playerId="playerId"
      :playerDerbies="derbies"
    />

    <p v-if="message !== null">
      {{ message }}
    </p>

    <loading-indicator v-if="isLoading" />
  </div>
</template>

<script>
import { HTTP } from '../../http-common.js';
import notifier from '../../notifier.js';

const LOADING_STATUS__INIT    = 1;
const LOADING_STATUS__LOADING = 2;
const LOADING_STATUS__NORMAL  = 3;
const LOADING_STATUS__ERROR   = 4;

import PlayerDerbiesTable from './PlayerDerbiesTable.vue';
import LoadingIndicator   from '../LoadingIndicator.vue';

export default {
  name: 'PlayerDerbies',

  components: {
    PlayerDerbiesTable,
    LoadingIndicator,
  },

  props: {
    playerId: {
      type: Number,
      required: true,
    }
  },

  data() {
    return {
      loadingStatus: LOADING_STATUS__INIT,
      derbies: null,
    };
  },

  computed: {
    /** @returns {boolean} */
    isLoading() {
      return this.loadingStatus === LOADING_STATUS__LOADING;
    },

    /** @returns {boolean} */
    isLoadedNormal() {
      return this.loadingStatus === LOADING_STATUS__NORMAL;
    },

    /** @returns {?string} */
    message() {
      if(!this.isLoadedNormal) {
        return null;
      }

      const derbies = this.derbies;
      if(derbies !== null && derbies.length === 0) {
        return 'Нет скачек.';
      }

      return null;
    },

    /** @returns {boolean} */
    isDerbiesTableVisible() {
      if(!this.isLoadedNormal) {
        return false;
      }

      const derbies = this.derbies;
      if(derbies === null) {
        return false;
      }

      return derbies.length > 0;
    },
  },

  created() {
    this.loadPlayerDerbies();
  },

  methods: {
    loadPlayerDerbies() {
      notifier.deleteSenderNotifications(this);

      this.loadingStatus = LOADING_STATUS__LOADING;

      const url = '/player/' + this.playerId + '/derbies';

      HTTP.get(url)
      .then(response => {
        const data = response.data.data;
        if(data === null) {
          notifier.showError('Invalid server response. data === null.', {sender: this});
          return;
        }

        this.derbies = data
        this.loadingStatus = LOADING_STATUS__NORMAL;
      })
      .catch(err => {
        this.loadingStatus = LOADING_STATUS__ERROR;
        notifier.showError(err, {sender: this});
      });
    },
  },
};
</script>
